module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files) ? _c('div', [_c('label', {
    attrs: {
      "for": "selectedFileName"
    }
  }, [_vm._v("Filename")]), _vm._v(" "), _c('label', {
    staticClass: "form-control",
    attrs: {
      "id": "selectedFileName",
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.getSelectedFileName()) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('file-upload', {
    ref: "upload",
    staticClass: "btn btn-default",
    attrs: {
      "post-action": _vm.getPostAction(),
      "multiple": false,
      "drop": true,
      "drop-directory": true,
      "id": "fileUpload"
    },
    on: {
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                Select file\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.files.length == 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Upload\n            ")])], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10a6ba3a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10a6ba3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/import-model-tags-dialog/import-model-tags-dialog.vue.html
// module id = 1077
// module chunks = 0